import { useSignal } from "~/sdk/signal";
import { invoke } from "~/runtime";
import type { Product } from "@decocms/apps-commerce/types";
import type { JSX } from "react";

export interface Props {
  productID: Product["productID"];
}

function Notify({ productID }: Props) {
  const loading = useSignal(false);
  const sent = useSignal(false);
  const error = useSignal(false);

  const handleSubmit = async (
    e: React.ChangeEvent<HTMLFormElement>,
  ) => {
    e.preventDefault();

    try {
      loading.value = true;
      error.value = false;

      const name = (e.currentTarget.elements.namedItem("name") as RadioNodeList)
        ?.value;
      const email = (
        e.currentTarget.elements.namedItem("email") as RadioNodeList
      )?.value;

      await invoke.vtex.actions.notifyme({ skuId: productID, name, email });
      sent.value = true;
    } catch {
      error.value = true;
    } finally {
      loading.value = false;
    }
  };

  return (
    <div className="flex flex-col items-center lg:items-start">
      <h3 className="font-['Poppins',Helvetica,Arial,sans-serif] uppercase text-base text-black font-semibold mt-5 mb-2.5">
        Avise-me
      </h3>
      <form
        className="flex flex-col justify-start gap-[18px]"
        onSubmit={handleSubmit}
      >
        <input
          className="border-[1px] border-[#2E2A2B] py-0 pr-[65px] pl-[21px] text-xs w-[341px] h-10"
          placeholder="Digite seu nome..."
          name="name"
        />

        <input
          className="border-[1px] border-[#2E2A2B] py-0 pr-[65px] pl-[21px] text-xs w-[341px] h-10"
          placeholder="Digite seu e-mail..."
          name="email"
        />

        <button
          className="bg-black text-white text-sm w-[341px] uppercase h-10 mb-[18px] disabled:opacity-70 disabled:cursor-not-allowed"
          disabled={loading.value || sent.value}
        >
          Avise-me quando chegar
        </button>
      </form>
      {sent.value && (
        <span className="font-['Poppins'] text-sm leading-[1.42857] not-italic text-[#5cb85c] font-bold">
          Cadastrado com sucesso, assim que o produto for disponibilizado você
          receberá um email avisando.
        </span>
      )}
      {error.value && (
        <span className="font-['Poppins'] text-sm leading-[1.42857] not-italic text-red-600 font-bold">
          Não foi possível cadastrar seu aviso. Tente novamente.
        </span>
      )}
    </div>
  );
}

export default Notify;
